import React from 'react';
import {Link} from 'react-router';
import * as pathConstants from '../../../constants/pathConstants';
const EmptySummaryText = () => {
  return (
    <div className="no-summary">
      <label>There's currently no 300A Summary data for this establishment.</label>
      <p>After you finish entering your 300A Summary data, you must submit the data to {}
        OSHA.</p>
      <ul>
        <li>You may submit data for a single establishment from this page.</li>
        <li>To submit multiple establishments at the same time go to the {}
          <Link to={pathConstants.pathToEstablishmentsDashboardPage}>Establishment List 
          Page</Link>.</li>
        <li>It is possible to edit and resubmit data in the event of changes or errors.</li>
      </ul>
    </div>
  );
};
export default EmptySummaryText;


/** WEBPACK FOOTER **
 ** ./src/components/establishment/singleEstablishment/EmptySummaryText.js
 **/